"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentSectionImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentSection operations. */
var DocumentSectionImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentSection class.
   * @param client Reference to the service client
   */
  function DocumentSectionImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentSectionImpl);
    this.client = client;
  }
  /**
   *  (Auth: Authorize)
   * @param portalId
   * @param hiveId
   * @param fullName
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentSectionImpl, [{
    key: "getChangedSections",
    value: function getChangedSections(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getChangedSectionsOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param hiveId
     * @param fullName
     * @param options The options parameters.
     */

  }, {
    key: "getAllDocumentSectionsTreeStructure",
    value: function getAllDocumentSectionsTreeStructure(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAllDocumentSectionsTreeStructureOperationSpec);
    }
  }]);
  return DocumentSectionImpl;
}(); // Operation Specifications


exports.DocumentSectionImpl = DocumentSectionImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getChangedSectionsOperationSpec = {
  path: "/api/Portals({portalId})/ChangedDocumentSections/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSectionDto"
            }
          }
        }
      }
    },
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName1],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getAllDocumentSectionsTreeStructureOperationSpec = {
  path: "/api/Portals({portalId})/AllDocumentSections/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentSectionTreeDto
    },
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName1],
  headerParameters: [Parameters.accept],
  serializer: serializer
};